export default __webpack_public_path__ + "static/media/services-icon.1f994065.svg";